<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M28.852 13.236l.038.096.009.023a6.743 6.743 0 01-2.245 7.763l-.014.012-5.56 4.164h.001l-2.735 2.071-1.667 1.258a1.12 1.12 0 01-1.355 0l-1.666-1.258-2.735-2.07.003-.003-.003-.003-5.53-4.14-.033-.024-.012-.01a6.74 6.74 0 01-2.236-7.79l.036-.095 3.637-9.468a.954.954 0 01.373-.45.972.972 0 011.111.06.953.953 0 01.322.49l2.451 7.498h9.924l2.45-7.498a.972.972 0 01.322-.489.972.972 0 011.111-.06c.17.107.3.265.374.45l3.63 9.473z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'brandGitlabFilled'
}
</script>
